// @ts-nocheck
import { FunctionComponent, useEffect, useState } from 'react';

//API

// components
import { Button } from '@raptormaps/button';
import RaptorModal from '../../../components/shared/Modal';
import { Row, Stack } from '@raptormaps/layout';

//styled components
import { CustomSelect, ModalOrgTitle } from '../styles/DefaultClientOrg_styles';

interface IEditModal {
  channelOptions: any;
  row: any;
  handleUpdateOrgChannel: any;
}

const EditModal: FunctionComponent<IEditModal> = ({
  channelOptions,
  row,
  handleUpdateOrgChannel,
}) => {
  const [selectedRow, setSelectedRow] = useState(null);

  useEffect(() => {
    setSelectedRow(row);
  }, [row]);

  const handleSelectedChannel = (ChannelId: number) => {
    let selectedOrg = channelOptions.find(item => item.id === ChannelId);
    handleUpdateOrgChannel(selectedOrg);
    setSelectedRow(null);
  };

  return (
    <RaptorModal
      title="Client Org Channel"
      show={selectedRow}
      close={() => setSelectedRow(null)}
      overlayClick={false}
    >
      <Stack align="start">
        <Row justify="space-between">
          <ModalOrgTitle>{selectedRow?.org_name}</ModalOrgTitle>
          <CustomSelect
            value={selectedRow?.channel_name}
            onChange={e => handleSelectedChannel(Number(e.target.value))}
          >
            <option value="">All</option>
            {channelOptions?.map(item => (
              <option value={item?.id}>{item?.name}</option>
            ))}
          </CustomSelect>
        </Row>
        <Button>Save</Button>
      </Stack>
    </RaptorModal>
  );
};

export default EditModal;
